import { jsxs as b, jsx as s } from "react/jsx-runtime";
import { forwardRef as F } from "react";
const X = {
  LG: "lg"
};
function Y(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var k = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var R;
function J() {
  return R || (R = 1, function(e) {
    (function() {
      var a = {}.hasOwnProperty;
      function u() {
        for (var r = "", t = 0; t < arguments.length; t++) {
          var n = arguments[t];
          n && (r = p(r, i(n)));
        }
        return r;
      }
      function i(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return u.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var t = "";
        for (var n in r)
          a.call(r, n) && r[n] && (t = p(t, n));
        return t;
      }
      function p(r, t) {
        return t ? r ? r + " " + t : r + t : r;
      }
      e.exports ? (u.default = u, e.exports = u) : window.classNames = u;
    })();
  }(k)), k.exports;
}
var K = J();
const P = /* @__PURE__ */ Y(K), Q = "_rotate_1xozj_1", rr = "_dash_1xozj_1", h = {
  "purpur-spinner": "_purpur-spinner_1xozj_1",
  rotate: Q,
  "purpur-spinner--xxs": "_purpur-spinner--xxs_1xozj_4",
  "purpur-spinner--xs": "_purpur-spinner--xs_1xozj_8",
  "purpur-spinner--sm": "_purpur-spinner--sm_1xozj_12",
  "purpur-spinner--md": "_purpur-spinner--md_1xozj_16",
  "purpur-spinner--lg": "_purpur-spinner--lg_1xozj_20",
  "purpur-spinner__circle": "_purpur-spinner__circle_1xozj_24",
  dash: rr,
  "purpur-spinner__circle--disabled": "_purpur-spinner__circle--disabled_1xozj_33",
  "purpur-spinner__circle--negative": "_purpur-spinner__circle--negative_1xozj_36"
}, v = "purpur-spinner", tr = {
  SM: "sm"
}, er = ({
  ["data-testid"]: e,
  disabled: a = !1,
  negative: u = !1,
  size: i = tr.SM,
  ...p
}) => /* @__PURE__ */ s(
  "div",
  {
    className: P([h[v], h[`${v}--${i}`]]),
    "data-testid": e,
    ...p,
    children: /* @__PURE__ */ s("svg", { viewBox: "0 0 50 50", children: /* @__PURE__ */ s(
      "circle",
      {
        className: P(h[`${v}__circle`], {
          [h[`${v}__circle--disabled`]]: a,
          [h[`${v}__circle--negative`]]: u
        }),
        cx: "25",
        cy: "25",
        r: "20"
      }
    ) })
  }
);
function nr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var C = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var z;
function ur() {
  return z || (z = 1, function(e) {
    (function() {
      var a = {}.hasOwnProperty;
      function u() {
        for (var r = "", t = 0; t < arguments.length; t++) {
          var n = arguments[t];
          n && (r = p(r, i.call(this, n)));
        }
        return r;
      }
      function i(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return u.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var t = "";
        for (var n in r)
          a.call(r, n) && r[n] && (t = p(t, this && this[n] || n));
        return t;
      }
      function p(r, t) {
        return t ? r ? r + " " + t : r + t : r;
      }
      e.exports ? (u.default = u, e.exports = u) : window.classNames = u;
    })();
  }(C)), C.exports;
}
var ar = ur();
const pr = /* @__PURE__ */ nr(ar), ir = {
  "purpur-button": "_purpur-button_w455q_1",
  "purpur-button--xs": "_purpur-button--xs_w455q_33",
  "purpur-button--icon-only": "_purpur-button--icon-only_w455q_36",
  "purpur-button--sm": "_purpur-button--sm_w455q_39",
  "purpur-button--md": "_purpur-button--md_w455q_45",
  "purpur-button--lg": "_purpur-button--lg_w455q_51",
  "purpur-button--full-width": "_purpur-button--full-width_w455q_57",
  "purpur-button--primary": "_purpur-button--primary_w455q_60",
  "purpur-button--disabled": "_purpur-button--disabled_w455q_64",
  "purpur-button--primary-negative": "_purpur-button--primary-negative_w455q_70",
  "purpur-button--secondary": "_purpur-button--secondary_w455q_82",
  "purpur-button--secondary-negative": "_purpur-button--secondary-negative_w455q_93",
  "purpur-button--expressive": "_purpur-button--expressive_w455q_104",
  "purpur-button--expressive-negative": "_purpur-button--expressive-negative_w455q_114",
  "purpur-button--negative": "_purpur-button--negative_w455q_126",
  "purpur-button--destructive": "_purpur-button--destructive_w455q_133",
  "purpur-button--destructive-negative": "_purpur-button--destructive-negative_w455q_143",
  "purpur-button--tertiary-purple": "_purpur-button--tertiary-purple_w455q_153",
  "purpur-button--tertiary-purple-negative": "_purpur-button--tertiary-purple-negative_w455q_166",
  "purpur-button--text-negative": "_purpur-button--text-negative_w455q_181",
  "purpur-button--text": "_purpur-button--text_w455q_181"
}, or = pr.bind(ir), d = "purpur-button", sr = ({
  children: e,
  className: a,
  ["data-testid"]: u,
  disabled: i = !1,
  fullWidth: p = !1,
  iconOnly: r,
  loading: t = !1,
  negative: n = !1,
  onClick: c,
  size: f = "md",
  variant: o,
  type: g = "button",
  ...x
}, S) => {
  if (r && o === "destructive")
    return null;
  const U = or(
    [
      d,
      `${d}--${n ? `${o}-negative` : o}`,
      `${d}--${f}`
    ],
    {
      [`${d}--icon-only`]: r,
      [`${d}--negative`]: n,
      [`${d}--full-width`]: p,
      [`${d}--disabled`]: i || t
    },
    a
  ), W = (A) => {
    i || t ? A.preventDefault() : c && c(A);
  }, j = !!x["aria-disabled"] || i || t;
  return /* @__PURE__ */ b(
    "button",
    {
      className: U,
      "data-testid": u,
      type: g,
      ref: S,
      "aria-disabled": j,
      onClick: W,
      ...x,
      children: [
        t && /* @__PURE__ */ s(er, { size: f === X.LG ? "xs" : "xxs", negative: n, disabled: j }),
        " ",
        e
      ]
    }
  );
}, H = F(sr);
H.displayName = "Button";
function lr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var L = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var M;
function _r() {
  return M || (M = 1, function(e) {
    (function() {
      var a = {}.hasOwnProperty;
      function u() {
        for (var r = "", t = 0; t < arguments.length; t++) {
          var n = arguments[t];
          n && (r = p(r, i(n)));
        }
        return r;
      }
      function i(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return u.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var t = "";
        for (var n in r)
          a.call(r, n) && r[n] && (t = p(t, n));
        return t;
      }
      function p(r, t) {
        return t ? r ? r + " " + t : r + t : r;
      }
      e.exports ? (u.default = u, e.exports = u) : window.classNames = u;
    })();
  }(L)), L.exports;
}
var cr = _r();
const dr = /* @__PURE__ */ lr(cr), $ = {
  "purpur-heading": "_purpur-heading_k9fhq_1",
  "purpur-heading--hyphens": "_purpur-heading--hyphens_k9fhq_8",
  "purpur-heading--negative": "_purpur-heading--negative_k9fhq_11",
  "purpur-heading--subsection-100": "_purpur-heading--subsection-100_k9fhq_14",
  "purpur-heading--title-100": "_purpur-heading--title-100_k9fhq_20",
  "purpur-heading--title-200": "_purpur-heading--title-200_k9fhq_26",
  "purpur-heading--title-300": "_purpur-heading--title-300_k9fhq_32",
  "purpur-heading--title-400": "_purpur-heading--title-400_k9fhq_38",
  "purpur-heading--title-500": "_purpur-heading--title-500_k9fhq_44",
  "purpur-heading--title-600": "_purpur-heading--title-600_k9fhq_50",
  "purpur-heading--title-700": "_purpur-heading--title-700_k9fhq_56",
  "purpur-heading--display-25": "_purpur-heading--display-25_k9fhq_62",
  "purpur-heading--display-50": "_purpur-heading--display-50_k9fhq_68",
  "purpur-heading--display-100": "_purpur-heading--display-100_k9fhq_74",
  "purpur-heading--display-200": "_purpur-heading--display-200_k9fhq_80"
}, fr = {
  TITLE100: "title-100"
}, q = "purpur-heading", V = ({
  children: e,
  className: a = "",
  enableHyphenation: u = !1,
  negative: i = !1,
  tag: p,
  variant: r = fr.TITLE100,
  ...t
}) => {
  const n = p, c = dr([
    a,
    $[q],
    $[`${q}--${r}`],
    {
      [$[`${q}--hyphens`]]: u,
      [$[`${q}--negative`]]: i
    }
  ]);
  return /* @__PURE__ */ s(n, { className: c, ...t, children: e });
};
V.displayName = "Heading";
function gr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var E = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var I;
function hr() {
  return I || (I = 1, function(e) {
    (function() {
      var a = {}.hasOwnProperty;
      function u() {
        for (var r = "", t = 0; t < arguments.length; t++) {
          var n = arguments[t];
          n && (r = p(r, i.call(this, n)));
        }
        return r;
      }
      function i(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return u.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var t = "";
        for (var n in r)
          a.call(r, n) && r[n] && (t = p(t, this && this[n] || n));
        return t;
      }
      function p(r, t) {
        return t ? r ? r + " " + t : r + t : r;
      }
      e.exports ? (u.default = u, e.exports = u) : window.classNames = u;
    })();
  }(E)), E.exports;
}
var vr = hr();
const yr = /* @__PURE__ */ gr(vr), mr = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, br = yr.bind(mr), Z = "purpur-icon", wr = "md", xr = (e) => e.filter((a) => Object.keys(a).length >= 1).map((a) => `${a.name}="${a.value}"`).join(" "), $r = ({ content: e = "", title: a } = {}) => {
  const u = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    a ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], i = a ? `<title>${a}</title>` : "";
  return `<svg ${xr(u)}>${i}${e}</svg>`;
}, qr = (e) => e.replace(/<(\/?)svg([^>]*)>/g, "").trim(), N = ({
  ["data-testid"]: e,
  svg: a,
  allyTitle: u,
  className: i,
  size: p = wr,
  ...r
}) => {
  const t = $r({
    content: qr(a.svg),
    title: u
  }), n = br(i, Z, `${Z}--${p}`);
  return /* @__PURE__ */ s(
    "span",
    {
      className: n,
      "data-testid": e,
      dangerouslySetInnerHTML: { __html: t },
      ...r
    }
  );
};
N.displayName = "Icon";
const Sr = {
  name: "alert-filled",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm1.038-14.81-.247 6.875h-1.566l-.247-6.876a1.03 1.03 0 1 1 2.06 0Zm.212 8.916c0 .649-.585 1.234-1.25 1.234-.649 0-1.25-.585-1.25-1.234 0-.633.601-1.234 1.25-1.234.665 0 1.25.601 1.25 1.234Z" clip-rule="evenodd"/></svg>',
  keywords: ["alert-filled"],
  category: "status"
}, Or = {
  name: "check-circle-filled",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm4.712-12.491a.875.875 0 1 0-1.424-1.018l-4.4 6.16-2.27-2.27a.875.875 0 0 0-1.237 1.238l3 3a.875.875 0 0 0 1.331-.11l5-7Z" clip-rule="evenodd"/></svg>',
  keywords: ["check-circle-filled"],
  category: "status"
}, Nr = {
  name: "close",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M4.864 4.864a.9.9 0 0 1 1.273 0L12 10.727l5.864-5.863a.9.9 0 0 1 1.272 1.272L13.273 12l5.863 5.864a.9.9 0 1 1-1.272 1.272L12 13.273l-5.863 5.863a.9.9 0 0 1-1.273-1.272L10.727 12 4.864 6.136a.9.9 0 0 1 0-1.272Z" clip-rule="evenodd"/></svg>',
  keywords: ["close"],
  category: "utility"
}, jr = {
  name: "error-filled",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 24" fill="currentColor"><path fill-rule="evenodd" d="M14.268 3.5c-.77-1.333-2.694-1.333-3.464 0l-8.66 15c-.77 1.333.192 3 1.732 3h17.32c1.54 0 2.502-1.667 1.733-3l-8.66-15Zm-.694 5.067-.247 6.876h-1.566l-.247-6.876a1.03 1.03 0 1 1 2.06 0Zm.212 8.917c0 .649-.585 1.234-1.25 1.234-.648 0-1.25-.585-1.25-1.234 0-.633.602-1.234 1.25-1.234.665 0 1.25.601 1.25 1.234Z" clip-rule="evenodd"/></svg>',
  keywords: ["error-filled"],
  category: "status"
}, Ar = {
  name: "info-filled",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10ZM10.9 7.786c0 .591.516 1.077 1.108 1.077.576 0 1.092-.486 1.092-1.077 0-.592-.516-1.078-1.092-1.078-.592 0-1.108.486-1.108 1.078Zm.167 9.74h1.866V9.94h-1.866v7.586Z" clip-rule="evenodd"/></svg>',
  keywords: ["info-filled"],
  category: "status"
};
function kr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var T = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var B;
function Rr() {
  return B || (B = 1, function(e) {
    (function() {
      var a = {}.hasOwnProperty;
      function u() {
        for (var r = "", t = 0; t < arguments.length; t++) {
          var n = arguments[t];
          n && (r = p(r, i(n)));
        }
        return r;
      }
      function i(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return u.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var t = "";
        for (var n in r)
          a.call(r, n) && r[n] && (t = p(t, n));
        return t;
      }
      function p(r, t) {
        return t ? r ? r + " " + t : r + t : r;
      }
      e.exports ? (u.default = u, e.exports = u) : window.classNames = u;
    })();
  }(T)), T.exports;
}
var Pr = Rr();
const Cr = /* @__PURE__ */ kr(Pr), y = {
  "purpur-paragraph": "_purpur-paragraph_1rh57_1",
  "purpur-paragraph--disabled": "_purpur-paragraph--disabled_1rh57_7",
  "purpur-paragraph--hyphens": "_purpur-paragraph--hyphens_1rh57_10",
  "purpur-paragraph--negative": "_purpur-paragraph--negative_1rh57_13",
  "purpur-paragraph--paragraph-100": "_purpur-paragraph--paragraph-100_1rh57_16",
  "purpur-paragraph--paragraph-100-medium": "_purpur-paragraph--paragraph-100-medium_1rh57_22",
  "purpur-paragraph--paragraph-100-bold": "_purpur-paragraph--paragraph-100-bold_1rh57_29",
  "purpur-paragraph--paragraph-200": "_purpur-paragraph--paragraph-200_1rh57_36",
  "purpur-paragraph--preamble-100": "_purpur-paragraph--preamble-100_1rh57_42",
  "purpur-paragraph--preamble-200": "_purpur-paragraph--preamble-200_1rh57_48",
  "purpur-paragraph--additional-100": "_purpur-paragraph--additional-100_1rh57_54",
  "purpur-paragraph--additional-100-medium": "_purpur-paragraph--additional-100-medium_1rh57_60",
  "purpur-paragraph--overline-100": "_purpur-paragraph--overline-100_1rh57_67",
  "purpur-paragraph--overline-200": "_purpur-paragraph--overline-200_1rh57_75"
}, zr = {
  PARAGRAPH100: "paragraph-100"
}, m = "purpur-paragraph", D = ({
  ["data-testid"]: e,
  children: a,
  className: u,
  disabled: i,
  enableHyphenation: p = !1,
  negative: r = !1,
  variant: t = zr.PARAGRAPH100,
  ...n
}) => {
  const c = Cr([
    u,
    y[m],
    y[`${m}--${t}`],
    {
      [y[`${m}--hyphens`]]: p,
      [y[`${m}--disabled`]]: i,
      [y[`${m}--negative`]]: r
    }
  ]);
  return /* @__PURE__ */ s("p", { ...n, className: c, "data-testid": e, children: a });
};
D.displayName = "Paragraph";
function Lr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var O = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var G;
function Mr() {
  return G || (G = 1, function(e) {
    (function() {
      var a = {}.hasOwnProperty;
      function u() {
        for (var r = "", t = 0; t < arguments.length; t++) {
          var n = arguments[t];
          n && (r = p(r, i(n)));
        }
        return r;
      }
      function i(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return u.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var t = "";
        for (var n in r)
          a.call(r, n) && r[n] && (t = p(t, n));
        return t;
      }
      function p(r, t) {
        return t ? r ? r + " " + t : r + t : r;
      }
      e.exports ? (u.default = u, e.exports = u) : window.classNames = u;
    })();
  }(O)), O.exports;
}
var Er = Mr();
const Ir = /* @__PURE__ */ Lr(Er), l = {
  "purpur-notification": "_purpur-notification_10qwf_1",
  "purpur-notification__top": "_purpur-notification__top_10qwf_14",
  "purpur-notification__header": "_purpur-notification__header_10qwf_20",
  "purpur-notification__close-button": "_purpur-notification__close-button_10qwf_25",
  "purpur-notification__icon": "_purpur-notification__icon_10qwf_30",
  "purpur-notification__body": "_purpur-notification__body_10qwf_33",
  "purpur-notification--success": "_purpur-notification--success_10qwf_36",
  "purpur-notification__heading": "_purpur-notification__heading_10qwf_39",
  "purpur-notification--warning": "_purpur-notification--warning_10qwf_45",
  "purpur-notification--error": "_purpur-notification--error_10qwf_54",
  "purpur-notification--info": "_purpur-notification--info_10qwf_63",
  "purpur-notification--hidden": "_purpur-notification--hidden_10qwf_72",
  "purpur-notification--has-close-button": "_purpur-notification--has-close-button_10qwf_76"
}, w = {
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
  INFO: "info"
}, Dr = Object.values(w), Zr = {
  POLITE: "polite",
  ASSERTIVE: "assertive"
}, Ur = Object.values(Zr), Tr = {
  ALERT: "alert",
  DIALOG: "dialog",
  ALERTDIALOG: "alertdialog"
}, Wr = Object.values(Tr), _ = "purpur-notification", Br = (e) => {
  switch (e) {
    case w.INFO:
      return Ar;
    case w.SUCCESS:
      return Or;
    case w.WARNING:
      return Sr;
    case w.ERROR:
      return jr;
  }
}, Gr = ({
  ["data-testid"]: e,
  ["aria-live"]: a,
  children: u,
  className: i,
  closeButtonAriaLabel: p,
  headingTag: r = "h4",
  role: t,
  status: n = "info",
  heading: c,
  hidden: f,
  id: o,
  onClose: g,
  ...x
}, S) => /* @__PURE__ */ b(
  "div",
  {
    id: o,
    "aria-labelledby": o ? `${o}-heading` : void 0,
    "aria-describedby": o ? `${o}-body` : void 0,
    "aria-live": a,
    "aria-hidden": !!f,
    className: Ir(i, l[_], l[`${_}--${n}`], {
      [l[`${_}--hidden`]]: f,
      [l[`${_}--has-close-button`]]: !!g
    }),
    "data-testid": e,
    ref: S,
    role: t,
    ...x,
    children: [
      /* @__PURE__ */ b("div", { className: l[`${_}__top`], children: [
        /* @__PURE__ */ b("div", { className: l[`${_}__header`], children: [
          /* @__PURE__ */ s(
            N,
            {
              "data-testid": e ? `${e}-icon` : void 0,
              className: l[`${_}__icon`],
              svg: Br(n),
              size: "md"
            }
          ),
          !!c && /* @__PURE__ */ s(
            V,
            {
              "data-testid": e ? `${e}-heading` : void 0,
              variant: "subsection-100",
              tag: r,
              className: l[`${_}__heading`],
              children: /* @__PURE__ */ b("span", { id: o ? `${o}-heading` : void 0, children: [
                " ",
                c
              ] })
            }
          )
        ] }),
        g && /* @__PURE__ */ s(
          H,
          {
            "data-testid": e ? `${e}-close-button` : void 0,
            variant: "tertiary-purple",
            size: "sm",
            iconOnly: !0,
            "aria-label": p,
            onClick: g,
            className: l[`${_}__close-button`],
            children: /* @__PURE__ */ s(N, { svg: Nr, size: "sm" })
          }
        )
      ] }),
      u && /* @__PURE__ */ s(
        "div",
        {
          "data-testid": e ? `${e}-body` : void 0,
          className: l[`${_}__body`],
          id: o ? `${o}-body` : void 0,
          children: typeof u == "string" ? /* @__PURE__ */ s(
            D,
            {
              "data-testid": e ? `${e}-paragraph` : void 0,
              variant: "paragraph-100",
              children: u
            }
          ) : u
        }
      )
    ]
  }
), Fr = F(Gr);
Fr.displayName = "Notification";
export {
  Zr as NOTIFICATION_ARIA_LIVE,
  Tr as NOTIFICATION_ROLE,
  w as NOTIFICATION_STATUS,
  Fr as Notification,
  Ur as notificationAriaLiveValues,
  Wr as notificationRoles,
  Dr as notificationStatuses
};
//# sourceMappingURL=notification.es.js.map
